export interface ContactIconProps {
  className?: string
  strokeColor?: string
}

export const PinIcon: React.FC<ContactIconProps> = ({
  className = '',
  strokeColor = '#F05123',
}) => (
  <div className={className}>
    <svg
      width="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 2.36755C8.52344 2.36755 5.5 5.24521 5.5 8.78943C5.5 12.8676 10 19.3302 11.6523 21.5624C11.7209 21.6566 11.8108 21.7333 11.9147 21.7862C12.0186 21.839 12.1335 21.8666 12.25 21.8666C12.3665 21.8666 12.4814 21.839 12.5853 21.7862C12.6892 21.7333 12.7791 21.6566 12.8477 21.5624C14.5 19.3311 19 12.8708 19 8.78943C19 5.24521 15.9766 2.36755 12.25 2.36755Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 11.3676C13.4926 11.3676 14.5 10.3602 14.5 9.11755C14.5 7.87491 13.4926 6.86755 12.25 6.86755C11.0074 6.86755 10 7.87491 10 9.11755C10 10.3602 11.0074 11.3676 12.25 11.3676Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

export const MailIcon: React.FC<ContactIconProps> = ({
  className = '',
  strokeColor = '#F05123',
}) => (
  <div className={className}>
    <svg
      width="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.125 4.61755H4.375C3.33947 4.61755 2.5 5.45702 2.5 6.49255V17.7426C2.5 18.7781 3.33947 19.6176 4.375 19.6176H20.125C21.1605 19.6176 22 18.7781 22 17.7426V6.49255C22 5.45702 21.1605 4.61755 20.125 4.61755Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 7.61755L12.25 12.8676L19 7.61755"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)

export const ChatBubbleIcon: React.FC<ContactIconProps> = ({
  className = '',
  strokeColor = '#F05123',
}) => (
  <div className={className}>
    <svg
      width="100%"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10114 18.3125C4.15692 18.1072 4.03364 17.8217 3.91598 17.6159C3.87935 17.5546 3.83961 17.4951 3.79692 17.4378C2.78783 15.9075 2.24998 14.1147 2.25005 12.2816C2.23364 7.01984 6.59676 2.75 11.9921 2.75C16.6974 2.75 20.625 6.00969 21.5429 10.3367C21.6804 10.9782 21.7498 11.6325 21.75 12.2886C21.75 17.5578 17.5552 21.8947 12.1599 21.8947C11.3021 21.8947 10.1443 21.6791 9.51286 21.5023C8.88145 21.3256 8.25098 21.0913 8.08833 21.0284C7.92197 20.9645 7.7453 20.9316 7.56708 20.9314C7.37241 20.9307 7.17962 20.9694 7.00036 21.0453L3.82083 22.1928C3.75117 22.2228 3.67736 22.2421 3.60192 22.25C3.54239 22.2498 3.48348 22.2378 3.42862 22.2147C3.37375 22.1916 3.32402 22.1579 3.28229 22.1154C3.24057 22.0729 3.20769 22.0226 3.18555 21.9673C3.16341 21.9121 3.15246 21.853 3.15333 21.7934C3.15724 21.7412 3.16667 21.6895 3.18145 21.6392L4.10114 18.3125Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  </div>
)
